import React from "react";
import { useSelector } from "react-redux";

const CanAccess = ({
 allowedRoles = [],
 permission = "", // single permission string
 permissions = [], // [OK] multiple permissions — ALL must be present (AND logic)
 children,
 fallback = null,
}) => {
 const user = useSelector((state) => state.auth?.userDetails);

 if (!user) return fallback;

 // 1. Admin check
 let roleName = "";
 if (typeof user.role === "string") {
 roleName = user.role;
 } else if (Array.isArray(user.role)) {
 roleName = user.role[0]?.name || "";
 } else if (typeof user.role === "object") {
 roleName = user.role?.name || "";
 }

 const cleanRole = roleName.toLowerCase();
 if (cleanRole === "admin") return <>{children}</>;

 const normalize = (str) => (str || "").toLowerCase().replace(/[:\s_-]/g, "");
 const userPerms = (user.permissionNames || []).map(p => normalize(p));

 const hasPerm = (perm) => {
 const req = normalize(perm);
 return (
 userPerms.includes(req) ||
 userPerms.includes(`read${req}`) ||
 userPerms.includes(`view${req}`)
 );
 };

 // 2. Multiple permissions check — ALL must pass (AND logic)
 if (permissions.length > 0) {
 const allGranted = permissions.every((p) => hasPerm(p));
 if (allGranted) return <>{children}</>;
 return fallback;
 }

 // 3. Single permission check
 if (permission) {
 if (hasPerm(permission)) return <>{children}</>;
 }

 // 4. Role check (legacy/fallback)
 if (allowedRoles.length > 0) {
 const isAllowed = allowedRoles
 .map((r) => r.toLowerCase())
 .includes(cleanRole);

 if (isAllowed) return <>{children}</>;
 }

 return fallback;
};

export default CanAccess;
